import React, { FC } from "react";
import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { DIALOG_STYLE } from "../SelectResources/context";

export const SelectResourcePath: FC = () => {
  return <SimpleDialogFallback context={DIALOG_STYLE} />;
};
